// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p6-0";